// src/api/apiCurrencies.js
import axios from "../utils/axios";

/// Get Currencies
export const getAllCurrencies = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("currencies", { params });
    return data;
};

/// Get Currency
export const getCurrency = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`currencies/${id}`);
    return data;
};

/// Create Currency
export const createCurrency = async (req) => {
    try {
        const { data } = await axios.post("currencies", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createCurrency error:", error);
        throw error;
    }
};

/// Update Currency
export const updateCurrency = async (req, id) => {
    try {
        const { data } = await axios.put(`currencies/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateCurrency error:", error);
        throw error;
    }
};

/// Delete Currency
export const deleteCurrency = async (id) => {
    try {
        const { data } = await axios.delete(`currencies/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteCurrency error:", error);
        throw error;
    }
};

/// Delete All Currencies
export const deleteAllCurrencies = async (req = []) => {
    try {
        const { data } = await axios.delete(
            "currencies/mass-destroy",
            { data: req },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllCurrencies error:", error);
        throw error;
    }
};

/// Restore Currency
export const restoreCurrency = async (id) => {
    try {
        const { data } = await axios.post(`currencies/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreCurrency error:", error);
        throw error;
    }
};

/// Restore multiple Currencies
export const restoreAllCurrencies = async (req = []) => {
    try {
        const { data } = await axios.post(
            "currencies/mass-restore",
            { ...req },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllCurrencies error:", error);
        throw error;
    }
};

/// Force Delete Currency
export const forceDeleteCurrency = async (id) => {
    try {
        const { data } = await axios.delete(`currencies/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteCurrency error:", error);
        throw error;
    }
};

/// Force Delete multiple Currencies
export const forceDeleteAllCurrencies = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "currencies/mass-force-delete",
            { data: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllCurrencies error:", error);
        throw error;
    }
};
